import { MultiStepForm, UserProfileModel } from '@nw/fields-manager';
import {
  ExternalServiceType,
  GetProductDetailsResponseType,
  InstallmentPricingDetailsType
} from '@nw/shared/data-access';

import { BaseProductDetail } from './BaseProductDetail';
import { ExternalManagedInstallmentPricingDetails } from './ExternalManagedInstallmentPricingDetails';

export class ExternalManagedInstallmentProductDetail extends BaseProductDetail {
  readonly installmentType = 'EXTERNAL_MANAGED' as const;
  readonly externalServiceType: ExternalServiceType | undefined;
  readonly externalServiceReferenceId: string | undefined;
  readonly initialPricingDetails: ExternalManagedInstallmentPricingDetails;
  currentPricingDetails: ExternalManagedInstallmentPricingDetails;

  constructor(
    productDetails: GetProductDetailsResponseType,
    userProfileDetails: UserProfileModel | null = null
  ) {
    super(productDetails);

    const installmentDetails: InstallmentPricingDetailsType | undefined =
      productDetails.product_details.installment_pricing_details;

    this.externalServiceType = installmentDetails?.external_service_type;
    this.externalServiceReferenceId =
      installmentDetails?.external_service_reference_id;

    this.initialPricingDetails = new ExternalManagedInstallmentPricingDetails(
      productDetails
    );
    this.currentPricingDetails = this.initialPricingDetails;
    this.form = this.parsedUserExtraInfoConfig
      ? new MultiStepForm(
          this.parsedUserExtraInfoConfig.registration_form_details,
          userProfileDetails,
          this
        )
      : undefined;
  }

  shouldShowCouponApplyButton(): boolean {
    return this.parsedExtraData?.should_show_coupon_apply_button ?? true;
  }

  updateCurrentDetailsWithReferralCodeResponse(
    pricingDetailsObject: ExternalManagedInstallmentPricingDetails
  ) {
    this.currentPricingDetails = pricingDetailsObject;
  }

  updateCurrentDetailsWithInitialPricingDetails() {
    this.currentPricingDetails = this.initialPricingDetails;
  }
}
